
export const SCK_PORTAL = 'msp';
export const SCK = '.sckcorp.co.kr';
export const NEW_SCK = '.spintech.co.kr';
export const SCK_COST = 'metering';

export const DOOSAN_SSO = 'cloudmpsso';
export const DOOSAN_PORTAL = 'cloudmpservice';
export const DOOSAN_COST = 'cloudmpmetering';
export const DOOSAN = '.doosan.com';

export const SCMP_SSO = 'scmpsso';
export const SCMP_PORTAL = 'scmpservice';
export const SCMP_COST = 'scmpcost';
export const SCMP = '.sec.samsung.net';

export const HYUNDAIMOVEX_SSO = 'cloudsso';
export const HYUNDAIMOVEX_PORTAL = 'cloudservice';
export const HYUNDAIMOVEX_COST = 'cloudcost';
export const HYUNDAIMOVEX = '.hyundaimovex.com';

export const WINS21_PORTAL = 'cloudservice';
export const WINS21 = '.wins21.com';

export const MDSOPSNOW_COST = 'cost';

export const MDSOPSNOW = '.mdsopsnow.com';

export const COMTEC_PORTAL = 'oasis';
export const COMTEC = '.comtec.co.kr';

export const HYUNDAI_AUTOEVER_SSO = 'sso-cmp';
export const HYUNDAI_AUTOEVER_PORTAL = 'service-cmp';
export const HYUNDAI_AUTOEVER_COST = 'metering-cmp';
export const HYUNDAI_AUTOEVER_KENOBI = 'cloudopti-cmp';
export const HYUNDAI_AUTOEVER = '.hmg.net';
export const HYUNDAI_AUTOEVER_NEW = '.hmg-corp.io';




// WEBPACK FOOTER //
// ./src/constants/urlConstants.js